import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import TkPopMaterialAcquisitionBulkDialog from "../dialogTypes/TkPopMaterialAcquisitionBulkDialog";

function TkPopMaterialAcquisitionBulkButton(props) {

    const { t } = useTranslation();

    const { id, refresh, onSuccess, createButtonName, customizeErrorMsgCallback, onTrigger, ...others } = props;

    const [open, setOpen] = useState(false);

    const [schema, setSchema] = useState();

    useEffect( () => {

        let schema = {

            name: "TkPopProductManage",
            type: "BASE TABLE",
            searchAll: false,

            columns: [

                {

                    name: "consignee",
                    type: "varchar(255)",
                    nullable: "NO",
                    default: null,
                    required: true,
                    formOrder: 0,
                    formItemType: "autocomplete",
                    codeInfo: {
                        tableName: "User",
                        nameColumn: ["fullName"],
                        valueColumn: "username",
                        seperator: ": ",
                        useEmptyValue: true,
                        emptyName: "term.none",
                        sortByName: true,
                    }

                },
                
            ]

        };

        setSchema(schema);

    }, []);

    const onOpen = () => {

        setOpen(true);
        onTrigger(true)
    };

    const onClose = () => {

        setOpen(false);
        onTrigger(false)
    };

    const onCreateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

    };

    const modifyUrlCallback = (url, id) => {

        if ( id === "ElectrodeProcessing" ) {

            return `${url}?${id}`;

        }

        return url;

    }

    return (

        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} createButtonName={createButtonName} {...others} />
            <TkPopMaterialAcquisitionBulkDialog
                id={id + "create-dialog"}
                mode="create"
                formId={id + "create-form"}
                title={t(`dialog.title.Produce.acquisitionBulk`)}
                schema={schema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                modifyUrlCallback={(url) => modifyUrlCallback(url, id)}
                noKeepOpen={true}
                menuId={id}
            />
        </>

    );
}

export default TkPopMaterialAcquisitionBulkButton;

